module.exports = __webpack_public_path__ + "img/b40462d.jpeg";